import type { FreeSlot } from "../../utils/compute-free-slots";
import {
  getDayName,
  getDayNumber,
} from "../../../../shared/types/date-helpers";

function getSlotColorClass(durationMinutes: number): string {
  if (durationMinutes >= 120)
    return "bg-green-100 text-green-700 border-green-300 dark:bg-green-900/20 dark:text-green-300 dark:border-green-700";
  if (durationMinutes >= 60)
    return "bg-amber-100 text-amber-700 border-amber-300 dark:bg-amber-900/20 dark:text-amber-300 dark:border-amber-700";
  return "bg-red-100 text-red-700 border-red-300 dark:bg-red-900/20 dark:text-red-300 dark:border-red-700";
}

function formatDuration(minutes: number): string {
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  if (h === 0) return `${m}min`;
  if (m === 0) return `${h}h`;
  return `${h}h${m}`;
}

interface SlotBadgeProps {
  readonly slot: FreeSlot;
}

function SlotBadge({ slot }: SlotBadgeProps) {
  return (
    <div
      className={`flex items-center justify-between px-3 py-2 rounded-lg border text-sm ${getSlotColorClass(slot.durationMinutes)}`}
    >
      <span className="font-medium">
        {slot.startTime} – {slot.endTime}
      </span>
      <span className="text-xs font-semibold">
        {formatDuration(slot.durationMinutes)}
      </span>
    </div>
  );
}

interface FreeSlotsDateProps {
  readonly date: string;
  readonly slots: FreeSlot[];
}

export function FreeSlotsDay({ date, slots }: FreeSlotsDateProps) {
  const dayTotal = slots.reduce((s, sl) => s + sl.durationMinutes, 0);

  return (
    <div className="p-4 bg-surface border border-border rounded-xl">
      <div className="flex items-center justify-between mb-3">
        <div className="text-sm font-semibold text-ink">
          {getDayName(date)} {getDayNumber(date)}
        </div>
        <div className="text-xs text-ink-muted">
          {slots.length === 0
            ? "Journée pleine"
            : `${formatDuration(dayTotal)} libres`}
        </div>
      </div>
      {slots.length === 0 ? (
        <p className="text-xs text-ink-faint italic">
          Aucun créneau disponible
        </p>
      ) : (
        <div className="flex flex-col gap-2">
          {slots.map((slot) => (
            <SlotBadge key={`${slot.startTime}-${slot.endTime}`} slot={slot} />
          ))}
        </div>
      )}
    </div>
  );
}
